export default "__VITE_ASSET__BnvB9oH$__"